import React from "react"
import { useDispatch, useSelector } from "react-redux"

import { Checkbox } from "components"
import { setDeliveryAreaName } from "@redux"
import { thousandSeparator } from "utils"
import classes from "./CheckboxDeliveryServiceInternal.module.scss"

const CheckboxDeliveryServiceInternal = (props) => {
  const {
    internalDeliveryFee,
    setInternalDeliveryFee
  } = props

  const dispatch = useDispatch()

  const deliveryInfo =
    useSelector(state => state.deliveryInfo)

  const locationOptions =
    useSelector(state => state.systemSettings.locationOptions)

  const handleChangeAreaName = (locationOption) => {
    setInternalDeliveryFee({
      fee: locationOption.deliveryFee
    })

    dispatch(
      setDeliveryAreaName(
        locationOption.areaName,
        locationOption.deliveryFee
      )
    )
  }

  return (
    locationOptions?.map((locationOption, index) =>
      <div
        key={index}
        onClick={() => handleChangeAreaName(locationOption)}
        className={classes["option"]}
      >
        <div className={classes["row"]}>
          <Checkbox
            className={classes["checkbox"]}
            checked={
              deliveryInfo.deliveryService === "internal" &&
              deliveryInfo.areaName === locationOption.areaName
            }
          />
          <span className={classes["checkbox-text"]}>
            {locationOption.areaName}
          </span>
        </div>

        <div className={classes["price"]}>
          {thousandSeparator(internalDeliveryFee?.fee)}
        </div>
      </div>
    )
  )
}

export default React.memo(CheckboxDeliveryServiceInternal)